import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  required?: boolean;
  options?: SelectOption[];
  className?: string;
  disabled?: boolean;
}

export const Select: React.FC<SelectProps> = ({ label, required, options = [], className = '', disabled, id: propId, ...props }) => {
  const brand = useBrand();
  const generatedId = React.useId();
  const id = propId || generatedId;
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium mb-1.5" style={{ color: brand.colors.text }}>
          {required && <span style={{ color: brand.colors.error }}>* </span>}{label}
        </label>
      )}
      <select
        id={id}
        className="w-full px-4 py-2.5 rounded-lg border text-sm focus:outline-hidden focus:ring-2 transition-all appearance-none bg-white"
        style={{
          borderColor: brand.colors.border,
          backgroundColor: disabled ? brand.colors.bgLight : 'white',
          color: disabled ? brand.colors.textMuted : brand.colors.text,
        }}
        disabled={disabled}
        {...props}
      >
        {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
      </select>
    </div>
  );
};
